import { theme } from "aaa";
import * as React from "react";

export const NativeIconButton = (props: {
    "aria-label"?: string,
    children: any,
    disabled?: boolean,
    focusStyle?: React.CSSProperties,
    style?: React.CSSProperties,
    onClick?: () => void,
    onClickWithEvent?: (event: React.MouseEvent) => void,
}) => {
    const [focus, setFocus] = React.useState(false);

    return (
        <button
            style={{
                outline: "none",
                padding: 12,
                margin: 0,
                border: "10px",
                boxSizing: "border-box",
                background: "none",
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "0px",
                cursor: "pointer",
                ...props.style
            }}
            disabled={props.disabled}
            onClick={props.onClick ?? props.onClickWithEvent ?? undefined}
            aria-label={props["aria-label"]}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
        >
            <div
                style={{
                    borderRadius: "50%",
                    boxShadow: focus ? theme.focusShadow : "none",
                    transition: "box-shadow 0.2s",
                    ...props.focusStyle
                }}
            >
                {props.children}
            </div>
        </button>
    );
};


// WEBPACK FOOTER //
// ./src/components/common/NativeIconButton.tsx